<template>
  <!-- Prevent user control when playing a pilot tour, excluding self-browsing mode is on -->
  <div
    v-if="isPilotPlaying && !isPilotSelfBrowsingMode"
    class="pilot-mask"
  />
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'PilotMask',
  computed: {
    ...mapGetters([
      'isPilotPlaying',
      'isPilotSelfBrowsingMode'
    ])
  }
}
</script>
<style lang="stylus" scoped>
.pilot-mask {
  position: fixed
  width: 100%
  height: 100%
  background-color: transparent
}
</style>
